import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./breadcrumbs.module.css";
import { Arrow1, BradeArrow } from "../../../Svg";
import { useSelector } from "react-redux";


const Breadcrumbs = () => {
  const { productDetails, products } = useSelector((state) => state.products || {});

  const ROUTE_LABELS = {
    aboutUs: "About Us",
    contact: "Contact",
    categories: "Categories",
    cart: "Cart",
    checkout: "Checkout",
    faq: "FAQ",
    service: "Services",
    manufacturers: "Manufacturers",

    customerBillingAddress: "Customer Billing Address",
    vendorBillingAddress: "Vendor Billing Address",
    manufactureSel: "Manufacturer Selection",

    productList: "Products",
    SimilarProductList: "Similar Products",
    subcategories: "Subcategories",
    productCode: "Product Details",

    bomManage: "BOM Manager",
    bomListing: "BOM Listing",
    prodComparision: "Product Comparison",

    fileUploadPreview: "File Upload Preview",
    quoteRequest: "Quote Request",
    crossRefer: "Cross Reference",

    exInventoryBuyItem: "Excess Inventory",
    exInventoryUpload: "Excess Inventory Upload",
    exInvFileUploadPreview: "Inventory File Preview",
    exInventoryListing: "Excess Inventory",
    exInventEnquiryForm: "Inventory Enquiry",

    wizardEnquiryForm: "Wizard Enquiry",
    wizardUpload: "Wizard Upload",

    myprofile: "My Profile",
    addNewUser: "Add New User",
    editAccountUser: "Edit Account User",
    ViewAccountUser: "View Account User",
    accountusers: "Account Users",

    userNotifications: "Notifications",
    userEnquires: "My Enquiries",
    userSchedulePO: "Scheduled POs",
    schedulePoDetails: "PO Details",
    reshedule: "Reschedule",
    allOrders: "All Orders",
    orderDetails: "Order Details",

    vendorprofile: "Vendor Profile",
    addNewVendor: "Add New Vendor",
    vendorNotifications: "Vendor Notifications",
    recievedEnquiries: "Received Enquiries",
    vendorEnquiryDetails: "Enquiry Details",
    allVendorOrders: "Vendor Orders",
    vendororderDetails: "Order Details",
    VendorPODetails: "PO Details",

    receivedEnquires: "Received Enquiries",
    receivedOrders: "Received Orders",
    receivedOrderdetails: "Order Details",

    schedulePO: "Schedule Purchase Order",
    scheduleAddCart: "Schedule Cart",
    scheduleCart: "Scheduled Cart",
  };

  const [isMobile, setIsMobile] = useState(false);
  const restrictedList = ["orderHistory", "Cartpage", "wishlist", "myaddress",];

  const path = useLocation();
  const location = decodeURIComponent(path.pathname);
  const pathnames = location.split("/").filter((x) => x);
  const initialPath = location.split("/")[1];

  const rawCategories = productDetails?.categories?.length 
    ? productDetails.categories 
    : (products?.data?.[0]?.categories || []);

  const displayCategories = React.useMemo(() => {
    if (!rawCategories || !Array.isArray(rawCategories) || rawCategories.length === 0) return [];

    const hasFixed = rawCategories.some(c => c?.name?.toLowerCase() === "fixed capacitors" || c?.name?.toLowerCase() === "fixed capacitor");
    if (!hasFixed) {
      const isCapacitorCategory = rawCategories.some(c => c?.name?.toLowerCase().includes("capacitor"));
      if (isCapacitorCategory) {
        const list = [...rawCategories];
        const capIdx = list.findIndex(c => c?.name?.toLowerCase() === "capacitors");
        const fixedObj = { _id: "Fixed Capacitors", name: "Fixed Capacitors" };
        if (capIdx !== -1) {
          list.splice(capIdx + 1, 0, fixedObj);
        } else {
          list.splice(1, 0, fixedObj);
        }
        return list;
      }
    }
    return rawCategories;
  }, [rawCategories]);


  const getLabel = (value, index, pathnames) => {
    const cleanValue = value.split("?")[0];

    if (index > 0 && pathnames[index - 1] && pathnames[index - 1].toLowerCase() === "productcode") {
      return cleanValue;
    }

    if (/^\d+$/.test(cleanValue)) return null;
    if (/^[0-9a-fA-F]{24}$/.test(cleanValue)) return null; // Hide MongoDB ObjectIds
    
    const matchedKey = Object.keys(ROUTE_LABELS).find(k => k.toLowerCase() === cleanValue.toLowerCase());
    if (matchedKey) return ROUTE_LABELS[matchedKey];

    return cleanValue.replace(/([A-Z])/g, " $1").replace(/-/g, " ").replace(/^./, (c) => c.toUpperCase());
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isProductCodePage = pathnames[0]?.toLowerCase() === "productcode";
  const productCodeParam = pathnames.length > 1 ? pathnames.slice(1).join("/") : "";
  const productPartNumber = productDetails?.productOverview?.productNumber?.[0];
  const productCodeLabel = productPartNumber || (/^[0-9a-fA-F]{24}$/.test(productCodeParam) ? "" : productCodeParam);

  return (
    <div
      className={styles.breadcrumbs}
      style={{
        display:
          isMobile && restrictedList.includes(initialPath) ? "none" : "flex",
      }}
    >
      {" "}

      <Link to="/" className={styles.homeLink}>
        Home
      </Link>

      {isProductCodePage ? (
        displayCategories.length > 0 ? (
          <>
            {displayCategories.map((cat) => (
              <span key={cat._id || cat.name} className={styles.breadcrumbItem}>
                <BradeArrow />{" "}
                <Link to={`/productList/${cat._id}`} className={styles.breadcrumbLink}>
                  {cat.name}
                </Link>
              </span>
            ))}
            {productCodeLabel && (
              <span className={styles.breadcrumbItem} style={{ color: "black" }}>
                <BradeArrow /> {productCodeLabel}
              </span>
            )}
          </>
        ) : (
          <>
            <span className={styles.breadcrumbItem}>
              <BradeArrow /> Product Details
            </span>
            {productCodeLabel && (
              <span className={styles.breadcrumbItem} style={{ color: "black" }}>
                <BradeArrow /> {productCodeLabel}
              </span>
            )}
          </>
        )
      ) : (
        pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;

          const label = getLabel(value, index, pathnames);
          if (!label) return null;

          return last ? (
            <span
              key={to}
              className={styles.breadcrumbItem}
              style={{ color: "black" }}
            >
              <BradeArrow /> {label}
            </span>
          ) : (
            <span key={to} className={styles.breadcrumbItem}>
              <BradeArrow />{" "}
              <Link to={to} className={styles.breadcrumbLink}>
                {label}
              </Link>
            </span>
          );
        })
      )}
    </div>
  );
};

export default Breadcrumbs;

